<template>
  <div class="site-page">
    <header class="site-header">
      <div class="site-header__inner">
        <div class="site-header__brand">
          <span class="site-header__title">安徽东流管件制造有限公司</span>
          <span class="site-header__subtitle">工业管道配件 · 船舶物料 · 专业制造</span>
        </div>
        <a class="site-header__tel" href="tel:18110678019">
          <span class="site-header__tel-icon">☎</span>
          <span>18110678019</span>
        </a>
      </div>
    </header>

    <main class="site-main">
      <div class="site-panel">
        <div class="site-panel__body">
          <el-tabs stretch class="site-tabs site-tabs--top">
            <el-tab-pane label="产品展示">
              <div class="product-section site-tab-pane-fill">
                <p class="product-section__hint">选择产品分类，点击图片可放大查看</p>
                <div class="product-layout">
                  <nav v-if="!isMobile" class="product-menu" aria-label="产品分类">
                    <div class="product-menu__head">
                      <span class="product-menu__head-dot"></span>
                      材料分类
                    </div>
                    <ul class="product-menu__list">
                      <li v-for="(cat, idx) in productCategories" :key="cat.label">
                        <button
                          type="button"
                          class="product-menu__btn"
                          :class="{ 'is-active': activeCategory === idx }"
                          @click="activeCategory = idx"
                        >
                          <span class="product-menu__idx">{{ formatCategoryIndex(idx) }}</span>
                          <span class="product-menu__text">{{ cat.label }}</span>
                          <span class="product-menu__arrow" aria-hidden="true">›</span>
                        </button>
                      </li>
                    </ul>
                  </nav>

                  <div v-else class="product-menu-mobile">
                    <button
                      v-for="(cat, idx) in productCategories"
                      :key="'m-' + cat.label"
                      type="button"
                      class="product-chip"
                      :class="{ 'is-active': activeCategory === idx }"
                      @click="activeCategory = idx"
                    >
                      {{ cat.label }}
                    </button>
                  </div>

                  <div class="product-main">
                    <div class="product-main__head">
                      <h3 class="product-main__title">{{ currentCategory.label }}</h3>
                      <span class="product-main__count">共 {{ currentCategory.images.length }} 件</span>
                    </div>
                    <div class="product-grid-wrap">
                      <el-row :gutter="16">
                        <el-col
                          :xs="12"
                          :sm="8"
                          :md="6"
                          :lg="6"
                          v-for="(image, index) in currentCategory.images"
                          :key="index"
                          class="product-col"
                        >
                          <div class="product_card" @click="openPreview(image)">
                            <div class="product_card__img-wrap">
                              <img
                                :src="image"
                                class="product_card__img"
                                :alt="getImageName(image, currentCategory.names)"
                              >
                            </div>
                            <div class="product_card__caption">
                              {{ getImageName(image, currentCategory.names) }}
                            </div>
                          </div>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <el-tab-pane label="关于我们">
              <div class="about-section site-tab-pane-scroll">
                <div class="site-intro-box">
                  <p>质量是一切合作的基础 · 保证质量 · 提高服务</p>
                </div>
                <div class="site-section-title">公司简介</div>
                <div class="site-text about-text">
                  安徽东流管件制造有限公司是一家专业生产工业管道配件及配套产品的工厂，本公司坐落于长江五虎的安庆，享有优越的地理位置和便利的交通。
                  主导产品为不锈钢、碳钢、双相钢等材料的金属管道配件，采用国际上先进的生产工艺，以国内及进口优质原材料制造各种弯头、三通、异径管、法兰等配套产品。
                  精良的设备、先进的工艺、齐全的工装，不仅可以根据国标GB、美标ASME、日标JIS、德标DIN、英标EN等标准生产精良的标准管件，亦可根据客户要求自主研发制造非标管道配件。
                  产品广泛应用于石油化工、天然气、电力、造船、造纸、冶金、纺织、制药、食品、城建等行业工程的建设和检修。
                  我公司秉承「质量是一切合作的基础，保证质量，提高服务」的企业精神，为客户提供高品质的产品，我们真诚期待与国内外朋友携手合作，共创未来。
                </div>
                <div class="site-section-title about-gallery-title">公司风貌</div>
                <el-row :gutter="16">
                  <el-col
                    :xs="24"
                    :sm="12"
                    v-for="(image, index) in cj_imageUrl"
                    :key="index"
                  >
                    <div class="about-image-wrap">
                      <img :src="image" class="about-image" alt="公司风貌">
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-tab-pane>

            <el-tab-pane label="物料查询">
              <div class="site-impa-wrap site-tab-pane-fill">
                <p v-if="!isMobile" class="impa-hint">支持 IMPA 编码与产品名称搜索，数据来源于合作平台</p>
                <div class="site-impa-frame">
                  <iframe
                    ref="impaFrame"
                    src="/impa-embed"
                    title="IMPA物料查询"
                    scrolling="auto"
                  ></iframe>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </main>

    <footer class="site-footer">
      <div class="site-footer__strip">船舶物料查询 · 工业管件 · 安徽东流管件制造有限公司</div>
      <div class="site-footer__body">
        <div class="site-footer__title">成功案例</div>
        <div class="partner-carousel-wrap">
          <el-carousel
            :interval="4500"
            class="partner-carousel"
            :height="carouselHeight"
            indicator-position="outside"
            :arrow="isMobile ? 'never' : 'hover'"
          >
            <el-carousel-item v-for="(group, gi) in partnerSlides" :key="'slide-' + gi">
              <div class="partner-row" :class="{ 'partner-row--single': group.length === 1 }">
                <div v-for="(img, ii) in group" :key="'logo-' + gi + '-' + ii" class="partner-card">
                  <img :src="img" class="partner-card__img" alt="合作案例">
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="site-footer__icp">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
          皖ICP备2024035470号-1 · 安徽东流管件制造有限公司 版权所有
        </a>
      </div>
    </footer>
  </div>

  <el-dialog
    v-model="previewDialogVisible"
    :width="previewWidth"
    class="preview-dialog"
    align-center
    destroy-on-close
  >
    <img :src="currentImageUrl" class="preview-image" alt="产品预览">
  </el-dialog>
</template>

<script>
export default {
  name: 'home-page',
  data() {
    return {
      previewDialogVisible: false,
      currentImageUrl: '',
      activeCategory: 0,
      isMobile: false,
      success_imageUrl: [
        require('@/assets/images/成功案例/img.png'),
        require('@/assets/images/成功案例/img_1.png'),
        require('@/assets/images/成功案例/img_2.png'),
        require('@/assets/images/成功案例/img_3.png'),
        require('@/assets/images/成功案例/img_4.png'),
        require('@/assets/images/成功案例/img_5.png'),
        require('@/assets/images/成功案例/img_6.png'),
        require('@/assets/images/成功案例/img_7.png')
      ],
      fl_imageUrl: [
        require('@/assets/images/法兰/1.jpg'),
        require('@/assets/images/法兰/2.jpg'),
        require('@/assets/images/法兰/3.jpg'),
        require('@/assets/images/法兰/4.jpg'),
        require('@/assets/images/法兰/5.jpg'),
        require('@/assets/images/法兰/6.jpg'),
        require('@/assets/images/法兰/7.jpg')
      ],
      fl_imageUrlNames: {
        '1': '带颈平焊法兰SORF',
        '2': '异形法兰定制',
        '3': '承插焊法兰SWRF',
        '4': '板式平焊法兰PLRF',
        '5': '盲板法兰BLRF',
        '6': '螺纹法兰THRF',
        '7': '高颈对焊法兰WNRJ'
      },
      dzfl_imageUrl: [
        require('@/assets/images/锻制法兰/1.jpg'),
        require('@/assets/images/锻制法兰/2.jpg'),
        require('@/assets/images/锻制法兰/3.jpg'),
        require('@/assets/images/锻制法兰/4.jpg'),
        require('@/assets/images/锻制法兰/5.jpg'),
        require('@/assets/images/锻制法兰/6.jpg'),
        require('@/assets/images/锻制法兰/7.jpg'),
        require('@/assets/images/锻制法兰/8.jpg'),
        require('@/assets/images/锻制法兰/9.jpg'),
        require('@/assets/images/锻制法兰/10.jpg'),
        require('@/assets/images/锻制法兰/11.jpg'),
        require('@/assets/images/锻制法兰/12.jpg'),
        require('@/assets/images/锻制法兰/13.jpg'),
        require('@/assets/images/锻制法兰/14.jpg'),
        require('@/assets/images/锻制法兰/15.jpg'),
        require('@/assets/images/锻制法兰/16.jpg'),
        require('@/assets/images/锻制法兰/17.jpg')
      ],
      dzfl_imageUrlNames: {
        '1': '20200622152321778214',
        '2': '不同类型法兰',
        '3': '丝扣法兰',
        '4': '丝扣法兰2',
        '5': '实物图',
        '6': '带颈承插法兰',
        '7': '平焊法兰',
        '8': '异形丝扣法兰',
        '9': '异形法兰',
        '10': '承插法兰',
        '11': '承插法兰2',
        '12': '承插焊法兰',
        '13': '泵盘法兰',
        '14': '白底',
        '15': '美标对焊松套法兰',
        '16': '锻制法兰白底',
        '17': '锻造螺纹法兰'
      },
      yyj_imageUrl: [
        require('@/assets/images/液压件/1.jpg'),
        require('@/assets/images/液压件/2.jpg'),
        require('@/assets/images/液压件/3.jpg'),
        require('@/assets/images/液压件/4.jpg'),
        require('@/assets/images/液压件/5.jpg'),
        require('@/assets/images/液压件/6.jpg'),
        require('@/assets/images/液压件/7.jpg'),
        require('@/assets/images/液压件/8.jpg'),
        require('@/assets/images/液压件/9.jpg'),
        require('@/assets/images/液压件/10.jpg'),
        require('@/assets/images/液压件/11.jpg'),
        require('@/assets/images/液压件/12.jpg'),
        require('@/assets/images/液压件/13.jpg'),
        require('@/assets/images/液压件/14.jpg'),
        require('@/assets/images/液压件/15.jpg'),
        require('@/assets/images/液压件/16.jpg'),
        require('@/assets/images/液压件/17.jpg'),
        require('@/assets/images/液压件/18.jpg'),
        require('@/assets/images/液压件/19.jpg'),
        require('@/assets/images/液压件/20.jpg'),
        require('@/assets/images/液压件/21.jpg'),
        require('@/assets/images/液压件/22.jpg'),
        require('@/assets/images/液压件/23.jpg')
      ],
      yyj_imageUrlNames: {
        '1': 'AFM-24°锥SAE法兰1',
        '2': 'AFM-24°锥SAE法兰2',
        '3': 'AFM-24°锥SAE法兰3',
        '4': 'SAE内螺纹法兰1',
        '5': 'SAE内螺纹法兰2',
        '6': 'SAE内螺纹法兰3',
        '7': 'SAE分体法兰',
        '8': '分体法兰',
        '9': '扩口法兰1',
        '10': '扩口法兰2',
        '11': '承插焊接直角法兰1',
        '12': '承插焊接直角法兰2',
        '13': '日标碳钢液压方法兰1',
        '14': '日标碳钢液压方法兰2',
        '15': '日标碳钢液压方法兰3',
        '16': '日标碳钢液压方法兰4',
        '17': '日标碳钢液压方法兰5',
        '18': '液压法兰定制',
        '19': '盲板法兰1',
        '20': '盲板法兰2',
        '21': '盲板法兰3',
        '22': '碳钢直通法兰',
        '23': '碳钢直通法兰2'
      },
      ccgj_imageUrl: [
        require('@/assets/images/承插管件/1.jpg'),
        require('@/assets/images/承插管件/2.jpg'),
        require('@/assets/images/承插管件/3.jpg'),
        require('@/assets/images/承插管件/4.jpg'),
        require('@/assets/images/承插管件/5.jpg'),
        require('@/assets/images/承插管件/6.jpg'),
        require('@/assets/images/承插管件/7.jpg'),
        require('@/assets/images/承插管件/8.jpg'),
        require('@/assets/images/承插管件/9.jpg'),
        require('@/assets/images/承插管件/10.jpg')
      ],
      ccgj_imageUrlNames: {
        '1': '90°内螺纹弯头',
        '2': '90度承插弯头',
        '3': '内螺纹三通',
        '4': '内螺纹管箍',
        '5': '承插三通',
        '6': '承插四通',
        '7': '承插式管座',
        '8': '承插式管箍',
        '9': '活接',
        '10': '直通管接头'
      },
      gygj_imageUrl: [
        require('@/assets/images/工业管件/1.jpg'),
        require('@/assets/images/工业管件/2.jpg'),
        require('@/assets/images/工业管件/3.jpg'),
        require('@/assets/images/工业管件/4.jpg'),
        require('@/assets/images/工业管件/5.jpg'),
        require('@/assets/images/工业管件/6.jpg'),
        require('@/assets/images/工业管件/7.jpg'),
        require('@/assets/images/工业管件/8.jpg'),
        require('@/assets/images/工业管件/9.jpg'),
        require('@/assets/images/工业管件/10.jpg')
      ],
      gygj_imageUrlNames: {
        '1': '法兰翻边',
        '2': '焊接180度弯头',
        '3': '焊接偏心大小头',
        '4': '焊接同心大小头',
        '5': '焊接四通',
        '6': '焊接短半径90度弯头',
        '7': '焊接等径三通',
        '8': '焊接长半径45度弯头',
        '9': '焊接长半径90°弯头',
        '10': '管帽'
      },
      wsgj_imageUrl: [
        require('@/assets/images/卫生管件/1.jpg'),
        require('@/assets/images/卫生管件/2.jpg'),
        require('@/assets/images/卫生管件/3.jpg'),
        require('@/assets/images/卫生管件/4.jpg'),
        require('@/assets/images/卫生管件/5.jpg'),
        require('@/assets/images/卫生管件/6.jpg'),
        require('@/assets/images/卫生管件/7.jpg'),
        require('@/assets/images/卫生管件/8.jpg'),
        require('@/assets/images/卫生管件/9.jpg'),
        require('@/assets/images/卫生管件/10.jpg')
      ],
      wsgj_imageUrlNames: {
        '1': '卫生级对焊由任',
        '2': '卫生级快装90度弯头',
        '3': '卫生级快装三通',
        '4': '卫生级快装接头',
        '5': '卫生级快装止回阀',
        '6': '卫生级快装球阀',
        '7': '卫生级快装蝶阀',
        '8': '卫生级焊接90度弯头',
        '9': '卫生级焊接三通°弯头',
        '10': '卫生级焊接大小头'
      },
      lwgj_imageUrl: [
        require('@/assets/images/螺纹管件/1.jpg'),
        require('@/assets/images/螺纹管件/2.jpg'),
        require('@/assets/images/螺纹管件/3.jpg'),
        require('@/assets/images/螺纹管件/4.jpg'),
        require('@/assets/images/螺纹管件/5.jpg'),
        require('@/assets/images/螺纹管件/6.jpg'),
        require('@/assets/images/螺纹管件/7.jpg'),
        require('@/assets/images/螺纹管件/8.jpg'),
        require('@/assets/images/螺纹管件/9.jpg'),
        require('@/assets/images/螺纹管件/10.jpg'),
        require('@/assets/images/螺纹管件/11.jpg'),
        require('@/assets/images/螺纹管件/12.jpg'),
        require('@/assets/images/螺纹管件/13.jpg'),
        require('@/assets/images/螺纹管件/14.jpg'),
        require('@/assets/images/螺纹管件/15.jpg'),
        require('@/assets/images/螺纹管件/16.jpg'),
        require('@/assets/images/螺纹管件/17.jpg'),
        require('@/assets/images/螺纹管件/18.jpg')
      ],
      lwgj_imageUrlNames: {
        '1': 'C型由任',
        '2': '丝口90度弯头',
        '3': '丝口四通(CROSS)',
        '4': '光面接头(COUPLING)',
        '5': '六角卜申(HEX.BUSHING)',
        '6': '六角外牙(HEX.NIPPLE)',
        '7': '内外牙由任(FLAT UNION M)',
        '8': '半光面接头(HALF COUPLING)',
        '9': '单丝接头(HOSE NIPPLE)',
        '10': '四角塞头(SQUARE PLUG)',
        '11': '圆管接头(TUBE NIPPLE)',
        '12': '异径弯头90°(RED.ELBOW90)',
        '13': '异径有边接头(RED.SOCKET)',
        '14': '接头(SOCKET BANDED)',
        '15': '焊接接头(WELDING BARREL)',
        '16': '等径螺纹三通(TEE)',
        '17': '管帽(ROUND CAP)',
        '18': '螺纹异径三通(RED.TEE)'
      },
      bxgfm_imageUrl: [
        require('@/assets/images/不锈钢阀门/1.jpg'),
        require('@/assets/images/不锈钢阀门/2.jpg'),
        require('@/assets/images/不锈钢阀门/3.jpg'),
        require('@/assets/images/不锈钢阀门/4.jpg'),
        require('@/assets/images/不锈钢阀门/5.jpg'),
        require('@/assets/images/不锈钢阀门/6.jpg'),
        require('@/assets/images/不锈钢阀门/7.jpg'),
        require('@/assets/images/不锈钢阀门/8.jpg'),
        require('@/assets/images/不锈钢阀门/9.jpg'),
        require('@/assets/images/不锈钢阀门/10.jpg'),
        require('@/assets/images/不锈钢阀门/11.jpg'),
        require('@/assets/images/不锈钢阀门/12.jpg'),
        require('@/assets/images/不锈钢阀门/13.jpg'),
        require('@/assets/images/不锈钢阀门/14.jpg'),
        require('@/assets/images/不锈钢阀门/15.jpg'),
        require('@/assets/images/不锈钢阀门/16.jpg'),
        require('@/assets/images/不锈钢阀门/17.jpg'),
        require('@/assets/images/不锈钢阀门/18.jpg'),
        require('@/assets/images/不锈钢阀门/19.jpg'),
        require('@/assets/images/不锈钢阀门/20.jpg'),
        require('@/assets/images/不锈钢阀门/21.jpg'),
        require('@/assets/images/不锈钢阀门/22.jpg'),
        require('@/assets/images/不锈钢阀门/23.jpg'),
        require('@/assets/images/不锈钢阀门/24.jpg'),
        require('@/assets/images/不锈钢阀门/25.jpg')
      ],
      bxgfm_imageUrlNames: {
        '1': '1PC丝口蝶形球阀',
        '2': '1PC手柄丝口球阀(Q11F)',
        '3': '2PC手柄丝口球阀(Q11F)',
        '4': '2PC手柄法兰式球阀(Q41)',
        '5': '2PC气动法兰式球阀',
        '6': '2PC高平台法兰式球阀',
        '7': '3PC丝口高平台球阀',
        '8': '3PC加长对焊球阀',
        '9': '3PC手柄丝口球阀(Q11F)',
        '10': '3PC手柄对焊球阀(Q11F)',
        '11': '3PC法兰式球阀',
        '12': '丝口Y型过滤器(SY11W)',
        '13': '丝口三通L型球阀(Q14W)',
        '14': '丝口三通T型球阀(Q15W)',
        '15': '丝口截止阀(J11W)',
        '16': '丝口旋启式止回阀(H14)',
        '17': '丝口立式止回阀(H12F)',
        '18': '丝口闸阀(Z11W)',
        '19': '对夹式手柄驱动蝶阀',
        '20': '对夹式止回阀(H71W)',
        '21': '对夹式蝶阀(涡轮驱动)',
        '22': '法兰式Y型过滤器(SY41)',
        '23': '法兰式截止阀(J41W)',
        '24': '法兰式止回阀(H41)',
        '25': '法兰式闸阀(Z41W)'
      },
      cj_imageUrl: [
        require('@/assets/images/车间/1.jpg'),
        require('@/assets/images/车间/2.jpg'),
        require('@/assets/images/车间/3.jpg'),
        require('@/assets/images/车间/4.jpg'),
        require('@/assets/images/车间/5.jpg'),
        require('@/assets/images/车间/6.jpg'),
        require('@/assets/images/车间/7.jpg'),
        require('@/assets/images/车间/8.jpg')
      ]
    }
  },
  computed: {
    productCategories() {
      return [
        { label: '法兰', images: this.fl_imageUrl, names: this.fl_imageUrlNames },
        { label: '锻制法兰', images: this.dzfl_imageUrl, names: this.dzfl_imageUrlNames },
        { label: '液压件', images: this.yyj_imageUrl, names: this.yyj_imageUrlNames },
        { label: '承插管件', images: this.ccgj_imageUrl, names: this.ccgj_imageUrlNames },
        { label: '工业管件', images: this.gygj_imageUrl, names: this.gygj_imageUrlNames },
        { label: '卫生管件', images: this.wsgj_imageUrl, names: this.wsgj_imageUrlNames },
        { label: '螺纹管件', images: this.lwgj_imageUrl, names: this.lwgj_imageUrlNames },
        { label: '不锈钢阀门', images: this.bxgfm_imageUrl, names: this.bxgfm_imageUrlNames }
      ]
    },
    currentCategory() {
      return this.productCategories[this.activeCategory] || this.productCategories[0]
    },
    partnerSlides() {
      const size = this.isMobile ? 1 : 3
      const slides = []
      for (let i = 0; i < this.success_imageUrl.length; i += size) {
        slides.push(this.success_imageUrl.slice(i, i + size))
      }
      return slides
    },
    carouselHeight() {
      return this.isMobile ? '92px' : '120px'
    },
    previewWidth() {
      return this.isMobile ? '92%' : '60%'
    }
  },
  mounted() {
    this.syncViewport()
    window.addEventListener('resize', this.syncViewport)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncViewport)
  },
  methods: {
    syncViewport() {
      this.isMobile = window.innerWidth < 768
    },
    formatCategoryIndex(idx) {
      return String(idx + 1).padStart(2, '0')
    },
    openPreview(imageUrl) {
      this.currentImageUrl = imageUrl
      this.previewDialogVisible = true
    },
    getImageName(imagePath, data) {
      const pathSegments = imagePath.split('/')
      const imageName = pathSegments[pathSegments.length - 1]
      const nameKey = imageName.split('.')[0]
      return data[nameKey]
    }
  }
}
</script>

<style scoped>
/* 白卡片内 Tabs 撑满固定高度 */
.site-tabs--top {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.site-tabs--top :deep(.el-tabs) {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.site-tabs--top :deep(.el-tabs__header) {
  flex-shrink: 0;
  margin-bottom: 0;
}

.site-tabs--top :deep(.el-tabs__content) {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.site-tabs--top :deep(.el-tab-pane) {
  height: 100%;
  overflow: hidden;
}

.site-tabs--top :deep(.el-tabs__nav-wrap::after) {
  height: 1px;
  background: var(--site-border);
}

.site-tabs--top :deep(.el-tabs__item) {
  font-size: 16px;
  color: var(--site-text-muted);
  height: 48px;
  line-height: 48px;
  padding: 0 20px;
  transition: color 0.2s;
}

.site-tabs--top :deep(.el-tabs__item.is-active) {
  color: var(--site-primary);
  font-weight: 700;
}

.site-tabs--top :deep(.el-tabs__active-bar) {
  background: linear-gradient(90deg, var(--site-primary), var(--site-primary-dark));
  height: 3px;
  border-radius: 2px;
}

/* 产品区 */
.product-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.product-section__hint,
.impa-hint {
  flex-shrink: 0;
  margin: 6px 0 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: var(--site-text-muted);
  background: var(--site-primary-light);
  border-radius: var(--site-radius-sm);
}

/* 产品区布局 */
.product-layout {
  display: flex;
  gap: 0;
  flex: 1;
  min-height: 0;
  border: 1px solid var(--site-border);
  border-radius: var(--site-radius-sm);
  overflow: hidden;
  background: #fff;
  box-shadow: var(--site-shadow-sm);
  align-items: stretch;
}

/* 左侧材料菜单 */
.product-menu {
  flex: 0 0 220px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-right: 1px solid var(--site-border);
  display: flex;
  flex-direction: column;
  min-height: 0;
  align-self: stretch;
}

.product-menu__head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  font-weight: 700;
  color: var(--site-accent);
  border-bottom: 1px solid var(--site-border);
  background: rgba(255, 255, 255, 0.6);
}

.product-menu__head-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--site-primary), var(--site-primary-dark));
  box-shadow: 0 0 0 3px rgba(8, 156, 239, 0.2);
}

.product-menu__list {
  list-style: none;
  margin: 0;
  padding: 8px;
  flex: 1;
  overflow-y: auto;
}

.product-menu__list::-webkit-scrollbar {
  width: 4px;
}

.product-menu__list::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.product-menu__btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px 12px;
  margin-bottom: 4px;
  border: 1px solid transparent;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.product-menu__btn:hover {
  background: rgba(255, 255, 255, 0.85);
  border-color: var(--site-border);
}

.product-menu__btn.is-active {
  background: #fff;
  border-color: var(--site-primary);
  box-shadow: 0 2px 12px rgba(8, 156, 239, 0.15);
}

.product-menu__btn.is-active .product-menu__idx {
  background: linear-gradient(135deg, var(--site-primary), var(--site-primary-dark));
  color: #fff;
}

.product-menu__btn.is-active .product-menu__text {
  color: var(--site-primary-dark);
  font-weight: 600;
}

.product-menu__btn.is-active .product-menu__arrow {
  color: var(--site-primary);
  opacity: 1;
  transform: translateX(2px);
}

.product-menu__idx {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: var(--site-text-muted);
  background: #e2e8f0;
  border-radius: 6px;
  transition: background 0.2s, color 0.2s;
}

.product-menu__text {
  flex: 1;
  font-size: 14px;
  color: var(--site-text);
  line-height: 1.3;
}

.product-menu__arrow {
  flex-shrink: 0;
  font-size: 18px;
  color: var(--site-text-muted);
  opacity: 0;
  transition: opacity 0.2s, transform 0.2s;
}

.product-menu__btn:hover .product-menu__arrow {
  opacity: 0.6;
}

/* 手机端分类 chips */
.product-menu-mobile {
  display: flex;
  gap: 8px;
  padding: 12px 12px 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.product-menu-mobile::-webkit-scrollbar {
  display: none;
}

.product-chip {
  flex-shrink: 0;
  padding: 8px 14px;
  border: 1px solid var(--site-border);
  border-radius: 999px;
  background: #f8fafc;
  color: var(--site-text-muted);
  font-size: 13px;
  font-family: inherit;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.product-chip.is-active {
  background: linear-gradient(135deg, var(--site-primary), var(--site-primary-dark));
  border-color: transparent;
  color: #fff;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(8, 156, 239, 0.35);
}

/* 产品主区 */
.product-main {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.product-main__head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px 0;
  border-bottom: 1px dashed var(--site-border);
  margin: 0 12px 12px;
  padding-bottom: 12px;
}

.product-main__title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  color: var(--site-accent);
}

.product-main__count {
  font-size: 12px;
  color: var(--site-text-muted);
  white-space: nowrap;
}

.product-grid-wrap {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 0 12px 12px;
}

.product-grid-wrap::-webkit-scrollbar {
  width: 6px;
}

.product-grid-wrap::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.product-col {
  margin-bottom: 16px;
}

.product_card {
  background: #fff;
  border: 1px solid var(--site-border);
  border-radius: var(--site-radius-sm);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.product_card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(8, 156, 239, 0.18);
  border-color: var(--site-primary);
}

.product_card__img-wrap {
  aspect-ratio: 1;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.product_card__img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.product_card__caption {
  padding: 10px 8px;
  text-align: center;
  font-size: 12px;
  line-height: 1.4;
  color: #fff;
  background: linear-gradient(135deg, var(--site-primary-dark), var(--site-primary));
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 关于我们 */
.about-section {
  padding: 8px 0;
}

.about-text {
  margin-bottom: 28px;
}

.about-gallery-title {
  margin-top: 8px;
}

.about-image-wrap {
  margin-bottom: 16px;
  border-radius: var(--site-radius-sm);
  overflow: hidden;
  border: 1px solid var(--site-border);
  box-shadow: var(--site-shadow-sm);
}

.about-image {
  width: 100%;
  display: block;
  vertical-align: middle;
}

/* 成功案例轮播 */
.partner-carousel-wrap {
  max-width: 960px;
  margin: 0 auto;
  padding: 16px 14px 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: var(--site-radius);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.partner-carousel :deep(.el-carousel__container) {
  border-radius: var(--site-radius-sm);
}

.partner-carousel :deep(.el-carousel__arrow) {
  background: rgba(255, 255, 255, 0.9);
  color: var(--site-primary-dark);
  width: 36px;
  height: 36px;
}

.partner-carousel :deep(.el-carousel__indicators--outside) {
  margin-top: 16px;
}

.partner-carousel :deep(.el-carousel__button) {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
  opacity: 1;
}

.partner-carousel :deep(.el-carousel__indicator.is-active .el-carousel__button) {
  background: #fff;
  width: 20px;
  border-radius: 4px;
}

.partner-row {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 20px;
  height: 100%;
  padding: 0 48px;
  box-sizing: border-box;
}

.partner-row--single {
  padding: 0 24px;
}

.partner-card {
  flex: 1;
  max-width: 260px;
  min-width: 0;
  height: 88px;
  background: #fff;
  border-radius: 10px;
  padding: 14px 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.partner-card__img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  object-position: center;
  display: block;
}

.preview-image {
  width: 100%;
  display: block;
  border-radius: var(--site-radius-sm);
}

.preview-dialog :deep(.el-dialog__body) {
  padding: 12px;
}

/* 手机 */
@media (max-width: 767px) {
  .site-tabs--top :deep(.el-tabs__item) {
    font-size: 14px;
    height: 44px;
    line-height: 44px;
    padding: 0 12px;
  }

  .product-layout {
    flex-direction: column;
    border: none;
    box-shadow: none;
    background: transparent;
    gap: 8px;
    flex: 1;
    min-height: 0;
  }

  .product-menu-mobile {
    flex-shrink: 0;
    padding: 0;
  }

  .product-main {
    flex: 1;
    min-height: 0;
    border: 1px solid var(--site-border);
    border-radius: var(--site-radius-sm);
    background: #fff;
    box-shadow: var(--site-shadow-sm);
    display: flex;
    flex-direction: column;
  }

  .product-main__head {
    margin: 0;
    padding: 12px 12px 10px;
  }

  .product-grid-wrap {
    flex: 1;
    min-height: 0;
    padding: 0 8px 10px;
  }

  .product_card__caption {
    font-size: 11px;
    min-height: 40px;
    padding: 8px 4px;
  }

  .about-text {
    font-size: 14px;
  }

  .partner-carousel-wrap {
    padding: 10px 8px 0;
  }

  .partner-carousel :deep(.el-carousel__indicators--outside) {
    margin-top: 8px;
  }

  .partner-card {
    max-width: 260px;
    width: 100%;
    height: 72px;
    margin: 0 auto;
    padding: 10px 16px;
  }
}

@media (min-width: 768px) {
  .product-menu__btn.is-active .product-menu__arrow,
  .product-menu__btn:hover .product-menu__arrow {
    opacity: 1;
  }
}
</style>
